// extracted by mini-css-extract-plugin
module.exports = {"Section1":"Section1_Section1__3ELcO","Picture":"Section1_Picture__1vkK4","PictureDiv":"Section1_PictureDiv__1Imbs","Content":"Section1_Content__1OlmR"};